import { Button, Table, TableBody, TableCell, TableHead, TableRow, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import clsx from "clsx";
import { BookingPrice, Listing, MonoText } from "components";
import GenderIcon from "components/GenderIcon";
import moment from "moment";
import PropTypes from "prop-types";
import React from "react";
import { Link as RouterLink } from "react-router-dom";
import snakeToCamel from "utils/snakeToTitle";

const useStyles = makeStyles(theme => ({
  root: {},
  content: {
    padding: 0
  },
  inner: {
    minWidth: 700
  },
  nameCell: {
    display: "flex",
    alignItems: "center"
  },
  actions: {
    padding: theme.spacing(1),
    justifyContent: "flex-end"
  },
  mono: {
    fontFamily: "Roboto Mono"
  }
}));

const Results = props => {
  const { className, models, filter, loading, onPageChange, title, ...rest } = props;
  console.log(models);
  const classes = useStyles();

  return (
    <Listing
      title={title}
      onPageChange={onPageChange}
      loading={loading}
      filter={filter}
      {...rest}
      className={clsx(classes.root, className)}
    >
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Lesson</TableCell>
            <TableCell>Slot</TableCell>
            <TableCell>Student</TableCell>
            <TableCell>Lesson</TableCell>
            <TableCell>Price</TableCell>
            <TableCell>Status</TableCell>
            <TableCell align="right">Actions</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {models.map(model => (
            <TableRow hover key={model.id}>
              <TableCell>
                <MonoText>{model.lesson_slot.name_en}{model.lesson_slot.name_zh ? " " + model.lesson_slot.name_zh : ""}</MonoText>
                <div><Typography variant="caption">{model.reference}</Typography></div>
              </TableCell>
              <TableCell>
                <MonoText>{`${moment(model.lesson_slot.start_at).format("DD/MM/YYYY")}`}</MonoText>
                <div><Typography variant="caption"><MonoText>{`${moment(model.lesson_slot.start_at).format("HH:mm")} - ${moment(model.lesson_slot.end_at).format("HH:mm")}`} ({model.lesson_slot.duration / 60} min)</MonoText></Typography></div>
              </TableCell>
              <TableCell>
                {model.student.name_en}{model.student.name_zh ? " " + model.student.name_zh : ""}<GenderIcon gender={model.student.gender} />
              </TableCell>
              <TableCell>
                {model.lesson_slot.name_en}{model.lesson_slot.name_zh ? " " + model.lesson_slot.name_zh : ""}
                <div><Typography variant="caption">{snakeToCamel(model.lesson_slot.type)}</Typography></div>
              </TableCell>
              <TableCell>
                <BookingPrice model={model} />
              </TableCell>
              <TableCell>
                {snakeToCamel(model.status)}
              </TableCell>
              <TableCell align="right">
                <Button color="primary" component={RouterLink} size="small" to={`/bookings/${model.id}/summary`} variant="outlined">
                  View
                </Button>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Listing>
  );
};

Results.propTypes = {
  className: PropTypes.string,
  loading: PropTypes.bool,
  onPageChange: PropTypes.func.isRequired,
  filter: PropTypes.object.isRequired,
  models: PropTypes.array.isRequired
};

Results.defaultProps = {
  loading: false,
  onPageChange: () => { },
  models: [],
  filter: {}
};

export default Results;